import Alpine from "alpinejs";

const docOverflow = () => {
	const state = Alpine.reactive({
		useCount: 0,
		scrollY: 0,
	});

	Alpine.effect(() => {
		if (state.useCount > 0) {
			state.scrollY = window.scrollY;
		}
		if (state.useCount == 0) {
			requestAnimationFrame(() => {
				window.scrollTo({ top: state.scrollY });
				state.scrollY = 0;
			});
		}
	});

	return {
		updateCount(amount: number) {
			state.useCount = Math.max(state.useCount + amount, 0);
		},

		getCount(): number {
			return state.useCount;
		},

		getScrollY(): number {
			return state.scrollY;
		},
	};
};

Alpine.store("docOverflow", docOverflow());
